import {Close} from "@mui/icons-material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select from "@mui/material/Select";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import {makeStyles} from "@mui/styles";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import {useEffect, useState} from "react";
import {toast} from "react-toastify";


const Form_ADS = props => {
    const {matterContacts, selectedMatter, selectedForm, xfaCombinedData, setXfaCombinedData, xfaGeneratedForm, modify, correspondenceEmail, totalDrawingSheets} = props;

    const [selectedXfa, setSelectedXfa] = useState({});
    const [entityEmail, setEntityEmail] = useState("");
    const [entityName, setEntityName] = useState("");
    const [selectedDate, setSelectedDate] = useState(moment(xfaCombinedData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter)?.data?.filingByReference?.date || null));

    const initialState = {
        hasSecrecyOrder: false,
        isTransitionApplication: false,
        assigneeIsOrganization: true,
        applicantIsInventor: false,
        publicationInfoRequest: {
            earlyPublication: false,
            notToPublish: false
        },
        correspondenceAndRepresentativeInfo: {
            type: "customer-number",
            legalEntities: [],
            correspondenceMails: correspondenceEmail ? [correspondenceEmail] : []
        },
        numberOfDrawingSheets: totalDrawingSheets,
        figureForPublication: "",
        filingByReference: {
            applicationNo: "",
            date: null,
            authority: ""
        },
        authorization: {
            ipDenied: false,
            epoDenied: false
        },
        applicantDetails: {
            inventorStatus: "",
            type: "assignee",
            inventorName: ""
        }
    };

    const [state, setState] = useState(initialState);

    const {
        hasSecrecyOrder,
        assigneeIsOrganization,
        applicantIsInventor,
        publicationInfoRequest: {earlyPublication, notToPublish},
        isTransitionApplication,
        correspondenceAndRepresentativeInfo: {type},
        numberOfDrawingSheets,
        figureForPublication,
        filingByReference: {applicationNo, date, authority},
        authorization: {ipDenied, epoDenied},
        applicantDetails
    } = state || initialState;

    useEffect(() => {
        const selectedItem = xfaCombinedData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);
        if (modify) {
            if (selectedItem) {
                if (xfaGeneratedForm?.statusCode === 500) {
                    toast.error("Failed to preview the form");
                } else {
                    selectedItem.data = xfaGeneratedForm;
                    setSelectedDate(moment(xfaGeneratedForm?.filingByReference?.date));
                    setSelectedXfa(selectedItem);
                    setState(xfaGeneratedForm);
                }
            }
        }
    }, []);

    useEffect(() => {
        const selectedItem = xfaCombinedData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);
        setSelectedXfa(selectedItem);
    }, [xfaCombinedData, selectedMatter, selectedForm]);

    useEffect(() => {
        const selectedItem = xfaCombinedData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);
        if (selectedItem?.data) {
            setState(selectedItem.data);
        } else {
            setState(initialState);
        }
    }, [selectedMatter, selectedForm]);

    useEffect(() => {

        setXfaCombinedData && setXfaCombinedData(previousData => {
            const newData = JSON.parse(JSON.stringify(previousData));

            const item = newData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);

            if (item) {
                if (!item.data) {
                    item.data = {};
                }
                item.data = state;
            }

            return newData;
        });
    }, [state]);

    const useStyles = makeStyles({
        smallRadio: {
            "& svg": {
                width: 20,
                height: 20
            },
            "& svg > circle": {
                width: 12,
                height: 12
            }
        },
        smallCheckbox: {
            "& svg": {
                width: 20,
                height: 20
            }
        },
        table: {
            border: "1px solid black"
        },
        row: {
            "&:nth-of-type(odd)": {
                backgroundColor: "#F5F5F5"
            },
            "&:nth-of-type(even)": {
                backgroundColor: "white"
            }
        }
    });

    const classes = useStyles();

    const handleChange = event => {
        let {name, type, checked, value} = event.target;
        const [mainKey, subKey] = name.split(".");

        if (mainKey === "applicantIsInventor") {
            value = value === "true";
        }

        if (subKey) {
            if (subKey === "notToPublish" || subKey === "earlyPublication") {
                setState(prevState => ({
                    ...prevState,
                    [mainKey]: {
                        ...prevState[mainKey],
                        notToPublish: checked ? subKey === "notToPublish" : false,
                        earlyPublication: checked ? subKey === "earlyPublication" : false
                    }
                }));
            } else {
                setState(prevState => ({
                    ...prevState,
                    [mainKey]: {
                        ...prevState[mainKey],
                        [subKey]: type === "checkbox" ? checked : value
                    }
                }));
            }
        } else {
            if (name !== "signatories") {
                setState(prevState => ({
                    ...prevState,
                    [name]: type === "checkbox" ? checked : value
                }));
            }
        }

        if (state.correspondenceAndRepresentativeInfo.type === "customer-number") {
            setState(prevState => ({
                ...prevState,
                correspondenceAndRepresentativeInfo: {
                    ...prevState.correspondenceAndRepresentativeInfo,
                    legalEntities: []
                }
            }));
        }
    };


    useEffect(() => {
        if (selectedDate !== null) {
            const offset = selectedDate._d.getTimezoneOffset(); // Get timezone offset in minutes
            const localDate = new Date(selectedDate._d.getTime() - offset * 60 * 1000); // Adjust date to local timezone
            const dateString = isNaN(localDate.getTime()) ? "" : localDate.toISOString().split("T")[0]; // Extract YYYY-MM-DD
            setState(prevState => ({
                ...prevState,
                filingByReference: {
                    ...prevState?.filingByReference,
                    date: dateString
                }
            }));
        } else {
            setState(prevState => ({
                ...prevState,
                filingByReference: {
                    ...prevState?.filingByReference,
                    date: null
                }
            }));
        }
    }, [selectedDate]);

    const filterMatterContacts = item => {
        if (item.party_type === "Attorney" && !selectedXfa?.data?.correspondenceAndRepresentativeInfo?.legalEntities?.find(entity => entity.name === item.party.name)) {
            return true;
        }
    };

    const handleAddEntity = () => {
        const selectedSignatory = matterContacts?.find(contact => contact.party?.name === entityName);

        setState(prevState => ({
            ...prevState,
            correspondenceAndRepresentativeInfo: {
                ...prevState.correspondenceAndRepresentativeInfo,
                legalEntities: [
                    ...prevState.correspondenceAndRepresentativeInfo?.legalEntities,
                    {
                        name: selectedSignatory.party.name,
                        first_name: selectedSignatory.party.first_name,
                        middle_name: selectedSignatory.party.middle_name,
                        last_name: selectedSignatory.party.last_name,
                        office_address_line1: selectedSignatory.party.office_address_line1,
                        office_address_line2: selectedSignatory.party.office_address_line2,
                        office_postal_code: selectedSignatory.party.office_postal_code,
                        office_city: selectedSignatory.party.office_city,
                        office_state: selectedSignatory.party.office_state,
                        office_country: selectedSignatory.party.office_country,
                        office_telephone: selectedSignatory.party.office_telephone,
                        reference_no: selectedSignatory.party.reference_no
                    }
                ]
            }
        }));

        setEntityName("");
    };

    const handleAddMail = () => {
        setState(prevState => ({
            ...prevState,
            correspondenceAndRepresentativeInfo: {
                ...prevState.correspondenceAndRepresentativeInfo,
                correspondenceMails: [...prevState.correspondenceAndRepresentativeInfo?.correspondenceMails, entityEmail]
            }
        }));

        setEntityEmail("");
    };

    const handleDeleteEntity = e => {
        const legalEntityName = e.currentTarget.name;

        setState(prevState => {
            let existingEntities = prevState?.correspondenceAndRepresentativeInfo?.legalEntities || [];
            let updatedEntities = existingEntities?.filter(entity => entity.name !== legalEntityName) || [];

            return {
                ...prevState,
                correspondenceAndRepresentativeInfo: {
                    ...prevState.correspondenceAndRepresentativeInfo,
                    legalEntities: [...(prevState.correspondenceAndRepresentativeInfo.legalEntities = updatedEntities)]
                }
            };
        });
    };

    const handleDeleteMail = e => {
        const correspondenceEmail = e.currentTarget.name;

        setState(prevState => {
            let existingMails = prevState?.correspondenceAndRepresentativeInfo?.correspondenceMails || [];
            let updatedMails = existingMails?.filter(mail => mail !== correspondenceEmail) || [];

            return {
                ...prevState,
                correspondenceAndRepresentativeInfo: {
                    ...prevState.correspondenceAndRepresentativeInfo,
                    correspondenceMails: [...(prevState.correspondenceAndRepresentativeInfo.correspondenceMails = updatedMails)]
                }
            };
        });
    };

    return (
        <div>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#D3D3D3",
                    color: "black",
                    padding: 0
                }}
            >
                <Box/>
                <Box>Form ADS</Box>
                {/* <IconButton>{isDownloading ? <CircularProgress sx={{ color: "blue" }} /> : <Download onClick={location.pathname.includes("/docgen/form/details") ? downloadForm : downloadGeneratedForm} />}</IconButton>
             */}
            </Box>
            <Box sx={{marginTop: "3%"}}>
                <Paper>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography sx={{marginLeft: "2%"}}>Select as applicable</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography>Secrecy Order 37 CFR 5.2</Typography>
                            <Box display="flex" justifyContent="center">
                                <FormControlLabel name="hasSecrecyOrder" control={<Checkbox className={classes.smallCheckbox} checked={hasSecrecyOrder} onChange={handleChange}/>}/>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography>Assignee Is </Typography>
                            <FormControlLabel name="assigneeIsOrganization" control={<Checkbox className={classes.smallCheckbox} checked={assigneeIsOrganization} onChange={handleChange}/>} label="Organization"/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography>Applicant Is</Typography>
                            <RadioGroup row={true} name="applicantIsInventor" value={applicantIsInventor} onChange={handleChange}>
                                <FormControlLabel value={false} control={<Radio className={classes.smallRadio}/>} label="Organization"/>
                                <FormControlLabel value={true} control={<Radio className={classes.smallRadio}/>} label="Inventor"/>
                            </RadioGroup>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography>Publication Information</Typography>
                            <FormControlLabel name="publicationInfoRequest.notToPublish" control={<Checkbox className={classes.smallCheckbox} checked={notToPublish} onChange={handleChange}/>} label="Request Not to Publish"/>
                            <FormControlLabel name="publicationInfoRequest.earlyPublication" control={<Checkbox className={classes.smallCheckbox} checked={earlyPublication} onChange={handleChange}/>} label="Request Early Publication"/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography>Transition Application</Typography>
                            <Box display="flex" justifyContent="center">
                                <FormControlLabel name="isTransitionApplication" control={<Checkbox className={classes.smallCheckbox} checked={isTransitionApplication} onChange={handleChange}/>}/>
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
            <Box sx={{marginTop: "3%"}}>
                <Paper>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography sx={{marginLeft: "2%"}}>
                                <span style={{color: "red"}}>*</span> Correspondence and Representative Information
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={1}></Grid>

                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <RadioGroup name="correspondenceAndRepresentativeInfo.type" value={type} onChange={handleChange}>
                                <FormControlLabel value="customer-number" control={<Radio className={classes.smallRadio}/>} label="Customer Number"/>
                                <FormControlLabel value="us-attorney-or-agent" control={<Radio className={classes.smallRadio}/>} label="US Patent Practitioner"/>
                            </RadioGroup>
                        </Grid>

                        {type && type !== "customer-number" ? (
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <Typography>Legal Entity</Typography>
                                    <FormControl fullWidth>
                                        <Select name="correspondenceAndRepresentativeInfo.legalEntities" size="small" value={entityName} onChange={e => setEntityName(e.target.value)} displayEmpty renderValue={() => (entityName !== "" ? entityName : "Select the Signatory")}>
                                            {matterContacts?.filter(p => filterMatterContacts(p)).length === 0 ? (
                                                <MenuItem value="">No signatories available</MenuItem>
                                            ) : (
                                                matterContacts
                                                    ?.filter(p => filterMatterContacts(p))
                                                    ?.map(item => (
                                                        <MenuItem key={item.id} value={item.party.name}>
                                                            {item.party.name}
                                                        </MenuItem>
                                                    ))
                                            )}
                                        </Select>
                                    </FormControl>

                                    <Table size="small" sx={{marginTop: "1%"}}>
                                        {selectedXfa?.data?.correspondenceAndRepresentativeInfo?.legalEntities?.length > 0 &&
                                            selectedXfa?.data?.correspondenceAndRepresentativeInfo?.legalEntities?.map(item => (
                                                <TableRow key={item.name} className={classes.row}>
                                                    <TableCell sx={{width: "70%"}}>{item.name}</TableCell>
                                                    {/* <TableCell sx={{ width: "10%" }}>{item.email}</TableCell> */}
                                                    <TableCell sx={{width: "10%"}}>
                                                        <IconButton name={item.name} onClick={e => handleDeleteEntity(e)}>
                                                            <Close style={{fontSize: 15}}/>
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                    </Table>

                                    <div style={{display: "flex", justifyContent: "flex-end", margin: "2%"}}>
                                        <span style={{marginRight: "2%"}}></span>
                                        <Button name="correspondenceAndRepresentativeInfo.legalEntities" variant="contained" color="primary" onClick={handleAddEntity} disabled={!entityName}>
                                            ADD
                                        </Button>
                                    </div>
                                </Grid>
                            ) :
                            <Grid item xs={12} sm={6} md={4} lg={3}></Grid>}

                        <Grid item xs={12} sm={6} md={4} lg={2.9}>
                            <br></br>
                            <TextField name="correspondenceAndRepresentativeInfo.correspondenceMails" value={entityEmail} size="small" label="Correspondence Email Id" onChange={e => setEntityEmail(e.target.value)}></TextField>
                            <Table size="small" sx={{marginTop: "1%"}}>
                            {selectedXfa?.data?.correspondenceAndRepresentativeInfo?.correspondenceMails?.length > 0 &&
                                    selectedXfa?.data?.correspondenceAndRepresentativeInfo?.correspondenceMails?.map(item => (
                                        <TableRow key={item} className={classes.row}>
                                            <TableCell sx={{width: "70%"}}>{item}</TableCell>
                                            <TableCell sx={{width: "10%"}}>
                                                <IconButton name={item} onClick={e => handleDeleteMail(e)}>
                                                    <Close style={{fontSize: 15}}/>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </Table>
                            <div style={{display: "flex", justifyContent: "flex-end", margin: "2%"}}>
                                <span style={{marginRight: "2%"}}></span>
                                <Button name="correspondenceAndRepresentativeInfo.legalEntities" variant="contained" color="primary" onClick={handleAddMail} disabled={!entityEmail}>ADD</Button>
                            </div>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
            <Box sx={{marginTop: "3%"}}>
                <Paper>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography sx={{marginLeft: "2%"}}>Drawing Sheets and Publication</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={1}></Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography>Total Number of Drawing Sheets</Typography>
                            <br/>
                            <TextField name="numberOfDrawingSheets" value={numberOfDrawingSheets} size="small" label="Enter here" fullWidth={false} onChange={handleChange}></TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography>Suggested Figure for Publication</Typography>
                            <br></br>
                            <TextField name="figureForPublication" value={figureForPublication} size="small" label="Enter here" fullWidth={false} onChange={handleChange}></TextField>
                        </Grid>
                    </Grid>
                    <br/>
                </Paper>
            </Box>
            <Box sx={{marginTop: "3%"}}>
                <Paper>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography sx={{marginLeft: "2%"}}>Filing by Reference</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={1}></Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography>Application number of the previously filed application</Typography>
                            <br/>
                            <TextField name="filingByReference.applicationNo" value={applicationNo} size="small" label="Enter here" onChange={handleChange}></TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2.5}>
                            <Typography>Filing Date</Typography>
                            <br/>
                            <br/>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Filing Date"
                                    value={date}
                                    onChange={newValue => {
                                        setSelectedDate(newValue);
                                    }}
                                    renderInput={params => <TextField {...params} size="small" error={false}/>}
                                    inputFormat="YYYY-MM-DD"
                                    maxDate={moment(new Date())}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography>Intellectual Property Authority/Country</Typography>
                            <br/>
                            <TextField name="filingByReference.authority" value={authority} size="small" label="Enter here" onChange={handleChange}></TextField>
                        </Grid>
                    </Grid>
                    <br/>
                </Paper>
            </Box>
            <Box sx={{marginTop: "3%"}}>
                <Paper>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography sx={{marginLeft: "2%"}}>Authorization or Opt-Out of Authorization to Permit Access</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={1}></Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControlLabel name="authorization.ipDenied" control={<Checkbox className={classes.smallCheckbox} checked={ipDenied} onChange={handleChange}/>} label="Do Not Authorize access to foreign IP Offices"/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2.5}>
                            <FormControlLabel name="authorization.epoDenied" control={<Checkbox className={classes.smallCheckbox} checked={epoDenied} onChange={handleChange}/>} label="Do Not Authorize transmission of Search Results to EPO"/>
                        </Grid>
                    </Grid>
                    <br/>
                </Paper>
            </Box>
            <Box sx={{marginTop: "3%"}}>
                <Paper>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={1.5}>
                            <Typography sx={{marginLeft: "2%"}}>Applicant Details</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={10.5}>
                            <RadioGroup row={true} name="applicantDetails.type" value={applicantDetails.type} onChange={handleChange}>
                                <Grid item xs={12} sm={6} md={4} lg={2}>
                                    <FormControlLabel value="assignee" control={<Radio className={classes.smallRadio}/>} label="Assignee"/>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                    <FormControlLabel value="legal-representative" control={<Radio className={classes.smallRadio}/>} label="Legal Representative under 35 U.S.C 117"/>
                                    {applicantDetails.type === "legal-representative" && (
                                        <>
                                            <RadioGroup row sx={{marginLeft: "4%"}} name="applicantDetails.inventorStatus" value={applicantDetails.inventorStatus} onChange={handleChange}>
                                                <FormControlLabel value="Legally Incapacitated" control={<Radio className={classes.smallRadio}/>} label="Legally Incapacitated"/>
                                                <FormControlLabel value="Deceased" control={<Radio className={classes.smallRadio}/>} label="Deceased"/>
                                            </RadioGroup>
                                            {applicantDetails.inventorStatus && (
                                                <>
                                                    <Grid item xs={12} sm={6} md={4} lg={7} sx={{marginLeft: "10%"}}>
                                                        <Typography>Name of the deceased or legally incapacitated inventor</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4} lg={5} sx={{marginLeft: "10%"}}>
                                                        <br/>
                                                        <TextField name="applicantDetails.inventorName" value={applicantDetails.inventorName} size="small" label="Enter here" onChange={handleChange}></TextField>
                                                    </Grid>
                                                </>
                                            )}
                                        </>
                                    )}
                                </Grid>
                                <Grid item xs={2}>
                                    <FormControlLabel value="joint-inventor" control={<Radio className={classes.smallRadio}/>} label="Joint Inventor"/>
                                </Grid>
                                <Grid item xs={2}>
                                    <FormControlLabel value="person" control={<Radio className={classes.smallRadio}/>} label="Person to whom the inventor is obliged to assign"/>
                                </Grid>
                                <Grid item xs={2}>
                                    <Box display="flex" justifyContent="center">
                                        <FormControlLabel value="party-of-interest" control={<Radio className={classes.smallRadio}/>} label="Person who shows sufficient proprietary interest"/>
                                    </Box>
                                </Grid>
                            </RadioGroup>
                        </Grid>
                    </Grid>
                    <br/>
                </Paper>
            </Box>
        </div>
    );
};

export default Form_ADS;